export default __webpack_public_path__ + "static/media/hakkımızda-ben.4453d701.png";